// extracted by mini-css-extract-plugin
export default {"moreAssets__container":"MoreAssets_moreAssets__container__JNCHm","moreAssets--list":"MoreAssets_moreAssets--list__l6Z6Z"};